export function determineEffectOfTechnicianLock(
  orderObjectId: string,
  technicianObjectId: string,
  force?: boolean,
) {
  let url = `${process.env.REACT_APP_ORIGIN}/orders/${orderObjectId}/lock-technician/${technicianObjectId}/check-impact`
  if (force !== undefined) {
    url += `?force=${force}`
  }
  return {
    method: 'POST',
    url,
  }
}

export function getAvailableTechniciansForOrderLock(orderObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/available/${orderObjectId}`,
  }
}

export function removeLockedTechnicianFromOrder(orderObjectId: string) {
  return {
    method: 'DELETE',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderObjectId}/locked-technician`,
  }
}
